import { render, staticRenderFns } from "./tuition.vue?vue&type=template&id=0becf0d3&scoped=true&"
import script from "./tuition.vue?vue&type=script&lang=js&"
export * from "./tuition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0becf0d3",
  null
  
)

export default component.exports